/**
 * Create a class name string from a list of class names
 *
 * @public
 *
 * @param classNames - Classnames to apply to a given element
 *
 * @returns A string of class names
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *     const className = addClassName('foo', 'bar', 'baz');
 *
 *     return <div className={className}>Hello World</div>;
 * }
 * ```
 */
export function addClassName(
  ...classNames: (string | null | undefined)[]
): string {
  return classNames.filter(Boolean).join(' ');
}
